import React from 'react'
import {Box, Tooltip, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import getObjectValue from 'libs/getObjectValue';
import TextInput from 'components/TextInput';
import Tr from 'translations/Translations';
import clsx from 'clsx';
import DealingsService from 'services/DealingsService';
import {withRouter} from "react-router";
import WarningIcon from '@material-ui/icons/Warning';
import InputLimits from 'constants/InputLimits';
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import WorkableIconEditButton from 'components/button/WorkableIconEditButton';
import mergeDealing from '../lib/mergeDealing';
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import WorkableIconConfirmButton from "components/button/WorkableIconConfirmButton";

const limits = InputLimits.procedure.dealings;

const style = theme => ({
    root: {
        '&>*:nth-child(1)': {
            flexGrow: 1,
        }
    },
    rootEdit: {
        '&>*:nth-child(2)': {
            flexGrow: 1,
            paddingLeft: theme.spacing(2),
        }
    },
    editInput: {},
    marginLeft: {
        marginLeft: theme.spacing(2),
    },
    title: {
        marginLeft: theme.spacing(),
        wordBreak: 'break-all',
    },
    rotate: {
        transform: 'rotate(180deg)'
    },
    cursorPointer: {
        cursor: 'pointer'
    }
})

function ElementTitle(
    {
        classes,
        index,
        id,
        onDelete,
        onOpen,
        formikProps,
        open,
        disableDelete,
        match,
    }) {

    const createId = (key) => `${id}.${key}`;
    const elementId = getObjectValue(createId('identity'), formikProps.values)
    const editable = getObjectValue('_editable', formikProps.values, true);

    const _editId = `${id}._edit`;
    const _touchedId = `${id}._touched`;
    const editTitle = getObjectValue(_editId, formikProps.values, false)
    const setEditTitle = x => {
        formikProps.setFieldValue(_editId, x);
        formikProps.setFieldValue(_touchedId, true);
    }

    const titleId = createId('name');
    const title = getObjectValue(titleId, formikProps.values)
    const titleError = getObjectValue(titleId, formikProps.errors)
    const titleTouched = getObjectValue(titleId, formikProps.touched)

    const demendId = match.params.id;

    const handleEdit = () => {
        if (editTitle && !(Boolean(titleError) && titleTouched)) {
            setEditTitle(false)
        } else if (!editTitle) {
            DealingsService.get(demendId, elementId).then(res => {
                mergeDealing(res, formikProps, id);
                setEditTitle(true);
            })
        }
    }

    const errors = getObjectValue(id, formikProps.errors, null);
    const touched = getObjectValue(id, formikProps.touched, null);

    const showTitleComponent = () => (
        <Box
            className={clsx(
                classes.marginLeft,
                classes.cursorPointer
            )}
            component='span'
            fontWeight='fontWeightBold'
            onClick={onOpen}
        >
            {title}
        </Box>
    )

    const editTitleComponent = () => (
        <TextInput
            limit={limits.NAME}
            className={classes.editInput}
            label={Tr('name')}
            id={titleId}
            formikProps={formikProps}
            multiline
        />
    )

    return (
        <GridBlock
            alignItems='center'
            className={clsx({
                [classes.root]: !editTitle,
                [classes.rootEdit]: editTitle,
            })}
            wrap='nowrap'
        >
            <div>
                <Typography
                    variant='body1'
                    className={classes.title}
                >
                    {index + 1}.
                    {!editTitle && showTitleComponent()}
                </Typography>
            </div>
            {editTitle && editTitleComponent()}
            {(errors && touched) &&
            <Tooltip title={Tr('complete_missing_data')} placement="top">
                <WarningIcon color='error'/>
            </Tooltip>
            }
            <GridBlock wrap='nowrap'>
                {editTitle ?
                    <WorkableIconConfirmButton
                        onClick={handleEdit}
                        color='primary'
                        disabled={!editable}
                    /> :
                    <WorkableIconEditButton
                        onClick={handleEdit}
                        color='primary'
                        disabled={!editable}
                    />
                }
                <WorkableIconDeleteButton
                    color='primary'
                    onClick={onDelete}
                    disabled={disableDelete || !editable}
                />
                <WorkableIconExpandButton
                    color='primary'
                    onClick={onOpen}
                    expanded={open}
                />
            </GridBlock>
        </GridBlock>
    )
}

ElementTitle.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(withRouter(ElementTitle));